

<template>

<!--
      <van-image v-if="StoreDiametreCoBChoose "
    width="100%"
   
    fit="cover"
    position="left"
    v-bind:src="StoreApi +'/images/co_b/' + LoadImageCoB + '.png'"
    @error="imageLoadError"
    :show-loading = false
  /> 
  
-->

    <van-image v-if="StoreDiametreCoBChoose"
    width="100%"
    class="img_maquette_cable"
    position="left"
    v-bind:src="StoreApi +'/images/co_b/' + LoadImageCoB + '.png'"
    :show-loading = false
  /> 



      <van-image v-if="!StoreDiametreCoBChoose"
    width="100%"
    class="opacity_low img_maquette_cable"
    position="left"
    v-bind:src="StoreApi +'/images/co_b/8yK_M2_C.png'"
    :show-loading = false
  /> 
  
          </template>
  
          <script>
          export default {
            components: {
            },
            data() {
              return {
             
              }
            },
            methods: {
              imageLoadError(){
                this.LoadImageCoB = "8yK_M2_C";
           
              },
       
            },
            created(){
            },
            computed: {
                   /** api APP */
                StoreApi() {
                  return this.$store.state.storeGlobal.StoreApi
                  },
                  /** diametre choisie ok */
                  StoreDiametreCoBChoose() {
                    return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoB.coB) 
                        ?  true
                        :  false
                },
                /** Type de diametre */
                StoreTypeDiametreCoB() {
                  return this.$store.state.storeCoB.coB.diametre.typeDiametre
                },

                 /** Type de câble */
                 StoreTypeFibreCodeRef() {
                  return this.$store.state.storeCable.cable.type.TypeFibreCodeRef
                },

                /** Type de connecteur coté A */
                StoreCodeRefCoB() {
                  return this.$store.state.storeCoB.coB.type.codeRefCoB
                },

                 /** Nombre de fibre */
                 StoreNbFibre() {
                  return this.$store.state.storeCable.cable.nombre.nbFibre
                },

              /**** Fonction pour chargement de l'image du connecteur a */
                LoadImageCoB(){
              
                    return this.StructureLinkImage
                },

                getLinkNombreFibre(){
                  if(this.StoreNbFibre == 24 ){
                    return 12;
                  }else{
                    return this.StoreNbFibre
                  }

                },

                getLinkDiametreFibre(){
                  if(this.StoreTypeDiametreCoB == "2mm" ){
                    return 'yK';
                  }else if(this.StoreTypeDiametreCoB == "900µ" ){
                    return 'yE'
                  }
                  else{
                    return 'error';
                  }

                },

                StructureLinkImage(){
                  return this.getLinkNombreFibre + this.getLinkDiametreFibre + '_' + this.StoreTypeFibreCodeRef + '_' + this.StoreCodeRefCoB
               },
  
            }
          
          
          }
  </script>